
import React from "react";
import { useAuth } from "../../hooks/auth";

import { Link } from "react-router-dom";

import {
  Navbar,
  Nav,
  Dropdown,
} from "react-bootstrap";

import Logo from "../../assets/imgs/logos/2025/alumisoft.svg";

const Head: React.FC = () => {      


  const { user, signOut } = useAuth();

    return(
        <>
        <header className="navbar navbar-eg navbar-expand-md pb-2">
          <div className="container-xl px-3 justify-content-between">
              <a className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pr-0 pr-md-4">
                  <img
                    alt="MOF"
                    src={Logo}
                    height="32"
                    
                    className="navbar-brand-image img-fluid"

                  />
              </a>
            
              <div className="navbar-nav flex-row order-md-last user">
                <div className="nav-item">
                  <Dropdown>
                    <Dropdown.Toggle variant="none" className="mr-3">
                      <i className="far fa-user icon"></i> {user?.nome}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Link className="dropdown-item" to="/Alumisoft/minhaConta">
                      Minha Conta
                    </Link>
                      <Dropdown.Item onClick={signOut}>Sair</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
          </div>
        </header>

        <div className="navbar navbar-light pt-0">
          <div className="container-xl">
            <Navbar expand="md" className="pl-0 pt-0">
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  <Link className="nav-link justify-content-start" to="/Alumisoft/home">
                    <i className="fas fa-home mr-1"></i> Home
                  </Link>
                  <Link className="nav-link justify-content-start" to="/Alumisoft/contratos">
                    <i className="fas fa-cubes mr-1"></i> Produtos Contratados
                  </Link>
                  <Link className="nav-link justify-content-start" to="/Alumisoft/faturas">
                    <i className="fas fa-barcode mr-1"></i> Faturas
                  </Link>
                  <Link className="nav-link justify-content-start" to="/Alumisoft/contato">
                    <i className="far fa-envelope mr-1"></i> Contato
                  </Link>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </>
    )
}
export default Head;